import type { ModeTransitionMessage as ModeTransitionMessageType } from "@hightouch/lib/llm/schema";
import type {
  AgentMode,
  ModeTransitionRequest,
} from "src/components/llm/types";

/**
 * Tooltip text for any CTA that will switch agent modes. Surfaces the
 * mode-switch side effect to the user without forcing the agent to spell it
 * out in every label.
 */
export const getModeTransitionTooltip = (target: AgentMode): string =>
  target === "auto" ? "This will exit Plan mode" : "This will enter Plan mode";

export const getDefaultSubmitLabel = (
  _content: ModeTransitionMessageType["content"],
): string => "Continue";

/**
 * Builds the ModeTransitionRequest payload sent when a ModeTransitionMessage's
 * primary CTA is fired. Shared by the in-card footer and the hoist hook so
 * both produce identical requests.
 */
export const buildModeTransitionRequest = (
  content: ModeTransitionMessageType["content"],
): ModeTransitionRequest => ({
  targetAgentMode: content.targetAgentMode,
  prompt: content.prompt,
  metadata: {
    modeTransitionSummary: {
      title: content.title,
      ...(content.description ? { description: content.description } : {}),
      actionLabel: content.submitLabel ?? getDefaultSubmitLabel(content),
      targetAgentMode: content.targetAgentMode,
    },
  },
});
